import React, { useState, useEffect } from "react";
import "../../Styles/HomeComponentsStyles/BrowserScreen.css";
import { makeStyles, Skeleton } from "@mui/material";
import { Box, Grid, Item, Typography, Button, Stack } from "@mui/material";
import priceChartImage from "../../images/priceChartImage.PNG";
import allStocksImage from "../../images/allStocksImage.PNG";
import stockPriceChartImage from "../../images/stockPriceChartImage.PNG";
import earningsImage from "../../images/earningsImage.PNG";
import RPChartImage from "../../images/RPChartImage.PNG";

const BrowserScreen = ({ theme }) => {
  // const [active, setActiveMenu] = useState(1);
  // const change = () => {
  //   active == 1
  //     ? setActiveMenu(2)
  //     : active == 2
  //     ? setActiveMenu(3)
  //     : active == 3 && setActiveMenu(1);
  // };
  // useEffect(() => {
  //   setTimeout(() => {
  //     console.log("23455");
  //     change();
  //     console.log(active);
  //   }, 4230);
  // }, [active]);

  return (
    <div className="browser__screen">
      <div className="header__rectangle">
        <span className="dot__one"></span>
        <span className="dot__two"></span>
        <span className="dot__three"></span>
        <div className="menu__bar">
          <span className={theme == "blue" ? "menu active one" : "menu"}>
            <div className="mini__box">
              <span className="mini__rectangle"></span>
              <span className="text">Stocks</span>
            </div>
          </span>
          <span className={theme == "yellow" ? "menu active two" : "menu"}>
            {" "}
            <div className="mini__box">
              {" "}
              <span className="mini__rectangle"></span>
              <span className="text">Earnings</span>
            </div>
          </span>
          <span className={theme == "green" ? "menu active three" : "menu"}>
            {" "}
            <div className="mini__box">
              {" "}
              <span className="mini__rectangle"></span>
              <span className="text">Analytics</span>
            </div>
          </span>
        </div>
      </div>
      <div className="container">
        <div className={`content__wrapper ${theme}`}>
          {new Array("blue", "yellow", "green").map((t) => (
            <div className="content">
              <Box
                className="inner__wrapper"
                sx={{ width: "100%", height: "100%" }}
              >
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "#e9eeF744",
                    height: "60px",
                    display: "flex",
                    alignItems: "center",
                    padding: "5px 20px",
                    justifyContent: "space-between",
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    width="7vw"
                    height="30px"
                    sx={{ backgroundColor: "rgb(240, 240, 240)" }}
                  />

                  <Box sx={{ display: "flex", gap: "20px" }}>
                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      width="5vw"
                      height="30px"
                      sx={{ backgroundColor: "rgb(240, 240, 240)" }}
                    />
                    <Skeleton
                      variant="circular"
                      animation="wave"
                      width="30px"
                      height="30px"
                      sx={{ backgroundColor: "rgb(240, 240, 240)" }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    height: "100%",
                    width: "100%",
                    padding: "30px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  {new Array(6).fill("1").map((i) => (
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <Skeleton
                        variant="rounded"
                        animation="wave"
                        width="28%"
                        height="30px"
                        sx={{ backgroundColor: "rgb(240, 240, 240)" }}
                      />
                      <Skeleton
                        variant="rounded"
                        animation="wave"
                        width="28%"
                        height="30px"
                        sx={{ backgroundColor: "rgb(240, 240, 240)" }}
                      />
                      <Skeleton
                        variant="rounded"
                        animation="wave"
                        width="28%"
                        height="30px"
                        sx={{ backgroundColor: "rgb(240, 240, 240)" }}
                      />
                    </Box>
                  ))}
                </Box>
                <div className={theme == t ? "inner active" : "inner"}></div>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                  className={
                    theme == t
                      ? "super__main__content active"
                      : "super__main__content"
                  }
                >
                  <img
                    className={
                      theme == t
                        ? "super__main__content__img active"
                        : "super__main__content__img"
                    }
                    style={{ height: "90%", width: "auto" }}
                    src={
                      t == "blue"
                        ? allStocksImage
                        : t == "yellow"
                        ? earningsImage
                        : RPChartImage
                    }
                  />
                </Box>
              </Box>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrowserScreen;
